export const MOCKED_SIMULATION_DELAY = 2 * 1000;